'use strict';

var FlightSeasonAggregationFactory = function FlightSeasonAggregationFactory(FlightThematicDataAggregationFactory) {
  function FlightSeasonAggregation() {
    FlightThematicDataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-season');
    this.aggregationProperty = 'season';
    this.overridingAggregationProperty = 'seasonOverride';
  }
  FlightSeasonAggregation.prototype = Object.create(FlightThematicDataAggregationFactory.prototype);
  FlightSeasonAggregation.constructor = FlightSeasonAggregation;
  return FlightSeasonAggregation;
};
FlightSeasonAggregationFactory.$inject = ['FlightThematicDataAggregationFactory'];
module.exports = FlightSeasonAggregationFactory;